function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";

/** ------------------------------------------------------------------------- **/

/* 调用方式
/* let url = urlFormat('zljgo://native_api?type=13&content=%7B%22bonus_id%22%3A8425%7D')
/* let url = urlFormat('zljgo://native_api?type=1&content=https%3A%2F%2Ffrontstatic.zhaoliangji.com%2Ftools%2Fash-cleaning%2Findex.html')
/**------------------------------------------------------------------------- **/
// import Taro from '@tarojs/taro'
import { getUrlParamsWithoutDecode } from './index';
/**
 * 协议地址转化
 * @param url
 * @returns {string|*}
 */

function nativeUrlFormat(url) {
  if (url.indexOf('zljgo://') >= 0) {
    var data = url.split('?').pop();
    var arr = data.split('&');
    var params = getParams(arr);
    params.type = Number(params.type);

    if (params.type !== 1) {
      if (params.content) {
        var obj = JSON.parse(decodeURIComponent(params.content));
        params.content = objectToString(obj);
      }
    }

    return typeFormat(params);
  } else if (url.indexOf('https://') >= 0) {
    return "/pages/web/web?url=".concat(encodeURIComponent(url));
  } else {
    return url;
  }
}
/**
 * 获取协议地址参数
 * @param arr
 * @returns {{}}
 */


function getParams(arr) {
  var params = {};

  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var keyArr = item.split('=');
      params[keyArr[0]] = keyArr[1];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return params;
}
/**
 * 对象转成字符串
 * @param params
 * @returns {string}
 */


function objectToString(params) {
  var keyArr = [];

  for (var key in params) {
    keyArr.push(key);
  }

  return keyArr.map(function (v) {
    return params[v] ? v + '=' + params[v] : '';
  }).join('&');
}
/**
 * 协议类型转化
 * @param params
 * @returns {string|null}
 */


function typeFormat(params) {
  var JQ_URL = 'https://jqh5.zhaoliangji.com/';

  var _getUrlParamsWithoutD = getUrlParamsWithoutDecode({
    url: location.href,
    decode: true
  }),
      openId = _getUrlParamsWithoutD.openId;

  switch (params.type) {
    case 1:
      // H5页面
      return '/pages/web/web?url=' + params.content;

    case 2:
      // 商品详情
      return '/pages/product-detail/product-detail?' + params.content;

    case 5:
      // 全新机
      return '/well-chosen/pages/product-detail/product-detail?' + params.content;

    case 10:
      // 没有回收模块，跳回收H5页面
      return '/pages/web/web?url=' + encodeURIComponent("".concat(JQ_URL, "?source=wx_xcx&partner_id=zhaoliangjixiaochengxu&openId="));

    case 12:
    case 132:
      // 没有租赁，只能跳首页
      return '/pages/home/home';

    case 13:
    case 9999:
      // 搜索页面
      return '/pages/product/product?' + params.content;

    case 17:
      // 分类页面
      return '/pages/cate/cate';

    case 18:
      // 购物车
      return '/pages/cart/cart';

    case 22:
      // 优惠券列表
      return '/pages/coupon/coupon';

    case 24:
      // 地址管理
      return '/pages/address/address';

    case 25:
      // 我的收藏
      return '/pages/collection/collection';

    case 27:
      // 保修卡
      return '/pages/guarantee/guarantee';

    case 35:
      // 订单列表
      return '/pages/user-order/user-order';

    case 37:
      // 确认订单
      return '/pages/order-confirm/order-confirm';

    case 39:
      // 分类页面卖手机，跳回收H5页面（类目）
      return '/pages/web/web?url=' + encodeURIComponent("".concat(JQ_URL, "#/classify?source=wx_xcx&partner_id=zhaoliangjixiaochengxu&").concat(params.content, "&openId=").concat(openId));

    case 57:
      // 订单详情
      return '/pages/user-order-detail/user-order-detail?' + params.content;

    case 58:
      // 直播首页 - 暂无
      return null;

    case 60:
      // 直播间 - 暂无
      return null;

    case 66:
      // 晒单详情 - 暂无
      return null;

    case 67:
      // 发布晒单 - 暂无
      return null;

    case 72:
      // 个人设置
      return '/pages/user/user';

    case 75:
      // 分类页面卖手机，跳回收H5页面（型号）
      return '/pages/web/web?url=' + encodeURIComponent("".concat(JQ_URL, "#/typeEvaluation?source=wx_xcx&partner_id=zhaoliangjixiaochengxu&").concat(params.content, "&openId=").concat(openId));

    case 84:
      // 靓选热销榜
      return '/well-chosen/pages/lxsc-more/lxsc-more';

    case 85:
      // 靓选抢购
      return '/well-chosen/pages/lxsc-more/lxsc-more';

    case 87:
      // 靓选首页
      return '/pages/well-chosen/home/home';

    case 88:
      // 靓选详情
      return '/well-chosen/pages/product-detail/product-detail?' + params.content;

    case 93:
      // 品牌馆 - 暂无
      return null;

    case 109:
      // 商品详情
      return '/pages/product-detail/product-detail?' + params.content;

    case 112:
      // 商品详情页第二版
      return '/pages/product-detail/product-detail?' + params.content;

    case 137:
      // 搜索
      return '/pages/search/search' + params.content;

    default:
      return '/pages/home/home';
  }
}

export default nativeUrlFormat;